import { galleryTypes } from "./types"


const setSearchTerm = searchTerm => {
    return {
        type: galleryTypes.SET_SEARCH_TERM,
        payload: { searchTerm },
    }
}

const setCategoria = categoria => {
    return {
        type: galleryTypes.SET_CATEGORIA,
        payload: { categoria },
    }
}

const setRubro = rubro => {
    return {
        type: galleryTypes.SET_RUBRO,
        payload: { rubro },
    }
}

const setSubRubro = subRubro => {
    return {
        type: galleryTypes.SET_SUBRUBRO,
        payload: { subRubro },
    }
}
const setPromocion = promocion => {
    return {
        type: galleryTypes.SET_PROMOCION,
        payload: { promocion },
    }
}

export const galleryActions = {
    setSearchTerm,
    setCategoria,
    setRubro,
    setSubRubro,
    setPromocion
}